import React from "react";
import { ImageDetailsList } from "../compare-images/image-details-list";
import { ImageViewer } from "../../../../shared/components/image-viewer/image-viewer";

export const CompareGallery = ({ title, selectedProduct, shipmentKey, shipmentProductKey, photographyWipKey, children }) => {
    const handleClick = (e) => {
        if (e.ctrlKey && e.button === 0) {
            window.open(`/image-browser/${shipmentKey}/${shipmentProductKey}`, "_blank", "noopener", "noreferrer");
        }
    };

    return (
        <>
            <div className="image-info -no-border">
                <h4>{title}</h4>
                <div className="image-info-wrapper">
                    <div className="product-image-item -big">
                        <div
                            onClick={handleClick}
                            className="product-image-container"
                        >
                            {shipmentKey && shipmentProductKey ? (
                                <ImageViewer
                                    photographyWipKey={photographyWipKey}
                                    url={selectedProduct.variation.urlId}
                                />
                            ) : (
                                <ImageViewer url={selectedProduct.variation.urlId} />
                            )}
                        </div>
                        <h5>{selectedProduct.variation.name}</h5>
                    </div>
                </div>
            </div>
            <div style={{ display: "flex" }}>
                <ImageDetailsList className="product-images">{children}</ImageDetailsList>
            </div>
        </>
    );
};
